document.addEventListener('DOMContentLoaded', function () {
    const gformBody = document.querySelector('.gform-body')
    if (gformBody) {
        gform.addFilter('gform_datepicker_options_pre_init', function (optionsObj, formId, fieldId) {
            // Apply to field 2 only

            optionsObj.minDate = 0

            return optionsObj
        })
    }
})
